module.exports = __webpack_public_path__ + "img/logo-full-white.4cb4554d.svg";